export default __webpack_public_path__ + "static/media/doc.156aea1b.svg";